import { Swarm } from "@lbs/swarm-client";

import {
	checkBetTicketSwarmQuery,
	doBetTerminalSwarmQuery,
	doBookBetTerminalSwarmQuery,
	getBetMaxStakeTerminalSwarmQuery,
	getFreeBetsTerminalSwarmQuery,
} from "src/common/swarm/queries/bet";
import { ISwarmBetMaxStakeTerminalResponse, ISwarmDoBetTerminalResponse, ISwarmFreeBetTerminalResponse } from "src/common/swarm/models/response";
import { BetTypeEnum } from "src/constants/enums/betType";
import { ISwarmDoBetTerminalRequest, ISwarmDoBookBetTerminalRequest, ISwarmGetFreeBetsRequest } from "src/common/swarm/models/request";
import {swarmRequest} from "src/common/swarm/swarmRequestMiddleware";

class TerminalSwarmActions {
	static requestMaxStake = async (eventIds: number[], betType: BetTypeEnum, systemMinCount?: number) => {
		const {
			data: { data: result },
		} = await Swarm.getInstance().getData(...getBetMaxStakeTerminalSwarmQuery(eventIds, betType, systemMinCount));

		return (result.data as ISwarmBetMaxStakeTerminalResponse).MaxStake;
	};

	static placeBet = async (request: ISwarmDoBetTerminalRequest) => {
		const {
			data: { data: result, code: errorCode },
		} = await Swarm.getInstance().getData(...doBetTerminalSwarmQuery(request));

		if (result?.result !== "OK") throw result || { errorCode };

		return result.details as ISwarmDoBetTerminalResponse;
	};

	static bookBet = async (request: ISwarmDoBookBetTerminalRequest) => {
		const {
			data: { data: result },
		} = await Swarm.getInstance().getData(...doBookBetTerminalSwarmQuery(request));

		return result;
	};

	static checkBetTicket = async (barcode: number) => {
		const { data } = await swarmRequest(checkBetTicketSwarmQuery(barcode), 'check_terminal_bet_ticket');
		return data;
	}

	static getFreeBets = async  (request: ISwarmGetFreeBetsRequest) => {
		const {
			data: { data: result },
		} = await Swarm.getInstance().getData<{ details?: ISwarmFreeBetTerminalResponse[] }>(...getFreeBetsTerminalSwarmQuery(request));

		return result;
	}
}

export default TerminalSwarmActions;
